export const toIsoWithTimezone = (isoTimeUTC: string) => isoTimeUTC + 'Z';
